import { fetchAPI } from './base'

export const getAppUserAPI = () => {
  return fetchAPI('users', {
    method: 'GET',
  })
}
